import React, { Fragment, useState, useEffect, useRef } from "react";
import {
  Grid,
  Box,
  Typography,
  TableContainer,
  Table,
  TableHead,
  tableCellClasses,
  TableBody,
  IconButton,
  TableRow,
  TableCell,
  Paper,
  CircularProgress,
  Tooltip,
  InputAdornment,
} from "@mui/material";
import SelectField from "components/Select";
import { EyeIcon, SearchIcon } from "assets";
import Colors from "assets/Style/Colors";
import { FontFamily } from "assets";
import InputField from "components/Input";
import ClientServices from "services/Client";
import { ErrorToaster } from "components/Toaster";
import { makeStyles } from "@mui/styles";
import styled from "@emotion/styled";
import { useForm } from "react-hook-form";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { CommaSeparator } from "utils";
import { PDFExport } from "@progress/kendo-react-pdf";
import Pagination from "components/Pagination";

// *For Table Style

const Row = styled(TableRow)(({ theme }) => ({
  border: 0,
}));

const Cell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    border: 0,
    padding: "15px",
    textAlign: "center",
    whiteSpace: "nowrap",
    background: Colors.primary,
    color: Colors.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    textAlign: "center",
    textWrap: "nowrap",

    padding: "5px !important",
    ".MuiBox-root": {
      display: "flex",
      gap: "6px",
      alignItems: "center",
      justifyContent: "center",
      ".MuiBox-root": {
        cursor: "pointer",
      },
    },
    svg: {
      width: "auto",
      height: "24px",
    },
    ".MuiTypography-root": {
      textTransform: "capitalize",
      fontFamily: FontFamily.NunitoRegular,
      textWrap: "nowrap",
    },
    ".MuiButtonBase-root": {
      padding: "8px",
      width: "28px",
      height: "28px",
    },
  },
}));

const useStyles = makeStyles({
  loaderWrap: {
    display: "flex",
    height: 100,
    "& svg": {
      width: "40px !important",
      height: "40px !important",
    },
  },
});

function ClaimedVehicles() {
  const navigate = useNavigate();
  const classes = useStyles();
  const contentRef = useRef(null);
  const tableHead = [
    "Claimed By",
    "Claim Date",
    "Auction House",
    "Buyer ID",
    "VIN",
    "LOT",
    "Make/Model/Color",
    "IP Address",
    "Location",
    "Mobile Device",
    "Attachment",
    "Dispute",
    "Disputed By",
    "Change To",
    "Changed By",
  ];

  // *For Client Dropdown
  const [clients, setClients] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);

  //* ForLoader
  const [loader, setLoader] = useState(false);

  // *For Filters
  const [filters, setFilters] = useState({});
  const [funds, setFunds] = useState();
  // *For Pagination
  const [totalCount, setTotalCount] = useState(0);
  const [pageLimit, setPageLimit] = useState(50);
  const [currentPage, setCurrentPage] = useState(1);
  // *For Vendor Costing
  const getAppliedFunds = async (page, limit, filter) => {
    // setLoader(true);
    // const Page = page ? page : currentPage;
    // const Limit = limit ? limit : pageLimit;
    // const Filter = { ...filters, ...filter };
    // setCurrentPage(Page);
    // setPageLimit(Limit);
    // try {
    //     let params = {
    //         page: Page,
    //         limit: Limit,
    //     };
    //     params = { ...params, ...Filter };
    //     const { data } = await ClientServices.getAppliedFunds(params);
    //     setFunds(data?.funds?.rows);
    //     setTotalCount(data?.funds?.count);
    // } catch (error) {
    //     ErrorToaster(error);
    // } finally {
    //     setLoader(false);
    // }
  };

  // *For Apply Filters
  const applyFilter = async () => {
    try {
      let data = {
        customer_id: selectedClient?.id,
        vin: getValues("vin"),
        lot: getValues("lot"),
      };

      getAppliedFunds(1, "", data);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm();

  // *For Clients
  const getClientDropdown = async () => {
    try {
      const { data } = await ClientServices.getClientDropdown();

      setClients(data?.customers?.rows);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const claimed = [
    { id: "yes", name: "Yes" },
    { id: "no", name: "No" },
  ];

  // *For Handle Filter
  const handleFilter = (data) => {
    getAppliedFunds(1, "", data);
  };

  useEffect(() => {
    getClientDropdown();
    getAppliedFunds();
  }, []);

  return (
    <Fragment>
      <Grid
        container
        spacing={1}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <Grid item xs={12} sm={12} md={11}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mr: 4,
              my: 4,
            }}
          >
            <Typography
              variant="h4"
              sx={{
                color: Colors.charcoalGrey,
                fontFamily: FontFamily.NunitoRegular,
              }}
            >
              Claimed Vehicles
            </Typography>
          </Box>
        </Grid>
        <Grid
          item
          md={11}
          component={"form"}
          onSubmit={handleSubmit(applyFilter)}
        >
          <Box
            sx={{
              m: "10px 0 10px 0",
              p: "10px",
            }}
          >
            <Grid container spacing={1} alignItems={"center"}>
              <Grid item xs={12} sm={3}>
                <InputField
                  size={"small"}
                  label={"Search"}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                  placeholder={"Search"}
                  register={register("search", {
                    // onChange: (e) => handleFilter({ search: e.target.value }),
                  })}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <SelectField
                  size="small"
                  label={"Dispute"}
                  options={claimed}
                  selected={selectedClient}
                  onSelect={(value) => {
                    setSelectedClient(value);
                  }}
                  error={errors?.client?.message}
                  register={register("client", {
                    // required: "Please select client.",
                  })}
                />
              </Grid>
              {/* <Grid item xs={12} md={2}>
                                <Box
                                    sx={{
                                        mt: "12px",
                                    }}
                                >
                                    <PrimaryButton type="submit" title="Search" />
                                </Box>
                            </Grid> */}
            </Grid>
          </Box>
        </Grid>

        <Grid item md={11}>
          <Box>
            <PDFExport
              ref={contentRef}
              landscape={true}
              paperSize="A4"
              margin={5}
              fileName="Rcvd-Applied Shipping"
            >
              <Box className="pdf-show" sx={{ display: "none" }}>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography
                    variant="h5"
                    sx={{
                      color: Colors.charcoalGrey,
                      fontFamily: FontFamily.NunitoRegular,
                      mb: 2,
                    }}
                  >
                    Claimed Vehicles
                  </Typography>
                  <Box
                    sx={{
                      fontWeight: 400,
                      fontSize: "12px",
                      mt: 1.5,
                      color: Colors.charcoalGrey,
                    }}
                  >
                    <span>Date: &nbsp;&nbsp;</span>
                    {moment().format("MM-DD-YYYY")}
                  </Box>
                </Box>
              </Box>
              <TableContainer
                component={Paper}
                sx={{
                  boxShadow: "0px 8px 18px 0px #9B9B9B1A",
                  borderRadius: 2,
                  maxWidth: "calc(100vw - 330px)",
                }}
                className="table-box"
              >
                <Table stickyHeader sx={{ minWidth: 500 }}>
                  <TableHead>
                    <Row>
                      {tableHead.map((cell, index) => (
                        <Cell className="pdf-table" key={index}>
                          {cell}
                        </Cell>
                      ))}
                    </Row>
                  </TableHead>
                  <TableBody>
                    {!loader ? (
                      funds?.length > 0 ? (
                        <Fragment>
                          {funds?.map((item, index) => (
                            <Row
                              key={index}
                              sx={{
                                bgcolor: index % 2 !== 0 && "#EFF8E7",
                              }}
                            >
                              <Cell className="pdf-table">
                                {item?.createdAt
                                  ? moment(item?.createdAt).format("DD-MM-YYYY")
                                  : "N/A"}
                              </Cell>
                              <Cell className="pdf-table">
                                CFA-{item?.id ?? "-"}
                              </Cell>
                              <Cell className="pdf-table">
                                {item?.details[0]?.costing?.booking?.vin ?? "-"}
                              </Cell>
                              <Cell className="pdf-table">
                                {item?.details[0]?.costing?.booking
                                  ?.lot_number ?? "-"}
                              </Cell>
                              <Cell className="pdf-table">
                                {item?.customer?.id ?? "-"}
                              </Cell>
                              <Cell className="pdf-table">
                                <Tooltip
                                  className="pdf-hide"
                                  title={item?.customer?.name ?? "-"}
                                  arrow
                                  placement="top"
                                  slotProps={{
                                    popper: {
                                      modifiers: [
                                        {
                                          name: "offset",
                                          options: {
                                            offset: [10, -2],
                                          },
                                        },
                                      ],
                                    },
                                  }}
                                >
                                  <span>
                                    {item?.customer?.name?.length > 12
                                      ? item?.customer?.name?.slice(0, 8) +
                                        "..."
                                      : item?.customer?.name}
                                  </span>
                                </Tooltip>
                                <Box
                                  component={"div"}
                                  className="pdf-show"
                                  sx={{ display: "none !important" }}
                                >
                                  {item?.customer?.name ?? "-"}
                                </Box>
                              </Cell>
                              <Cell className="pdf-table">
                                ${" "}
                                {isNaN(+item?.cash_amount) &&
                                isNaN(+item?.vault_amount) &&
                                isNaN(+item?.bank_amount)
                                  ? "0"
                                  : (CommaSeparator(
                                      +item?.cash_amount ||
                                        +item?.vault_amount ||
                                        +item?.bank_amount,
                                    ) ?? "0")}
                              </Cell>

                              <Cell className="pdf-table">
                                <Tooltip
                                  className="pdf-hide"
                                  title={item?.creator?.name ?? "-"}
                                  arrow
                                  placement="top"
                                  slotProps={{
                                    popper: {
                                      modifiers: [
                                        {
                                          name: "offset",
                                          options: {
                                            offset: [10, -2],
                                          },
                                        },
                                      ],
                                    },
                                  }}
                                >
                                  <span>
                                    {item?.creator?.name?.length > 12
                                      ? item?.creator?.name?.slice(0, 8) + "..."
                                      : item?.creator?.name}
                                  </span>
                                </Tooltip>
                                <Box
                                  component={"div"}
                                  className="pdf-show"
                                  sx={{ display: "none !important" }}
                                >
                                  {item?.creator?.name ?? "-"}
                                </Box>
                              </Cell>
                              <Cell>
                                <Box
                                  component={"div"}
                                  className="pdf-hide"
                                  sx={{ gap: "16px !important" }}
                                >
                                  {true && (
                                    <Box
                                      onClick={() => {
                                        const url = new URL(
                                          window.location.origin +
                                            `/shipping-payment-details/${item?.id}`,
                                        );
                                        url.searchParams.append(
                                          "shipping",
                                          "true",
                                        );
                                        window.open(
                                          url.toString(),
                                          "_blank",
                                          "noopener,noreferrer",
                                        );
                                      }}
                                    >
                                      <IconButton
                                        sx={{
                                          bgcolor: Colors.primary,
                                          "&:hover": {
                                            bgcolor: Colors.primary,
                                          },
                                        }}
                                      >
                                        <EyeIcon />
                                      </IconButton>
                                      <Typography variant="body2">
                                        View Detail
                                      </Typography>
                                    </Box>
                                  )}
                                </Box>
                              </Cell>
                            </Row>
                          ))}
                        </Fragment>
                      ) : (
                        <Row>
                          <Cell
                            colSpan={tableHead.length + 1}
                            align="center"
                            sx={{ fontWeight: 600 }}
                          >
                            No Data Found
                          </Cell>
                        </Row>
                      )
                    ) : (
                      <Row>
                        <Cell
                          colSpan={tableHead.length + 2}
                          align="center"
                          sx={{ fontWeight: 600 }}
                        >
                          <Box className={classes.loaderWrap}>
                            <CircularProgress />
                          </Box>
                        </Cell>
                      </Row>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </PDFExport>
            <Grid item md={12} mb={3}>
              <Pagination
                currentPage={currentPage}
                pageSize={pageLimit}
                onPageSizeChange={(size) =>
                  getAppliedFunds(1, size.target.value)
                }
                tableCount={funds?.length}
                totalCount={totalCount}
                onPageChange={(page) => getAppliedFunds(page, "")}
              />
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Fragment>
  );
}

export default ClaimedVehicles;
